<ng-container *ngIf="isLoading; else pageContent">
	<div class="app-spinner">
		<mat-spinner diameter="60"></mat-spinner>
		</div>
</ng-container>

<ng-template #pageContent>
<div class="course-page">

    <h1 class="title">Published Courses</h1>
    <p class="subtitle">View and manage Courses across all classrooms</p>

    <div class="top-bar">
        <input type="text" class="search-input" placeholder="Search by Course Name"
		[(ngModel)]="searchCourseByName" 
		  (ngModelChange)="onSearchChange($event)"
		>
		<ng-container>
        <ng-container  *ngIf="!classroomFilter || classroomFilter == 0; else chipTemplate">
            <div class="select-wrapper">
                <select class="filter-select"
				[(ngModel)]="classroomFilter"
				(change)="onFilterChange()"
				>
                    <option [value]="0">All Classrooms</option>
                    <option *ngFor="let classroomName of classrooms"
					[value]="classroomName.id"> {{classroomName.name}} </option>
                </select>
                <i class="bi bi-chevron-down select-arrow"></i>
            </div>
			</ng-container>
			<ng-template #chipTemplate>
			<div class="filter-chip" *ngIf="classroomFilter && classroomFilter != 0">
              Classroom: <span>{{ getSelectedClassroomName() }}</span>
             <span class="close-icon" (click)="clearClassroom()">✕</span>
            </div>
			</ng-template>
        </ng-container>
    </div>

    <div class="table-card">
        <table class="course-table">
            <thead>
                <tr>
                    <th>S.NO</th>
                    <th>Course Name</th>
                    <th>Classroom</th>
                    <th>Published Date</th>
                    <th>Taught By</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="studentCourses.length > 0; else noCoursesData">
                    <tr *ngFor="let studentCourse of studentCourses; let i = index">
                        <td>{{ (pageNo - 1) * pageSize + i + 1 }}</td>
                        <td class="course-name">{{studentCourse.course_title}}</td>
                        <td>{{studentCourse.classroom}}</td>
                        <td>{{studentCourse.published_date | date:'MMM d, y'}}</td>
                        <td>
						<span class="course-badge al-course">{{studentCourse.teacher_name}}</span>
					   </td>
                        <td><button class="btn-add" (click)="goToCoursePage(studentCourse)">View </button></td>
                    </tr>
                </ng-container>
				<ng-template #noCoursesData>
                   <tr>
                        <td colspan="6">
                            <div class="empty-row">No courses available</div>
                        </td>
                    </tr>
				</ng-template>
            </tbody>
        </table>

   <p-paginator [rows]="pageSize" [totalRecords]="totalPages" [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100]"
            (onPageChange)="onPageChange($event)">
    </p-paginator>

    </div>
</div>
</ng-template>